<div class="container-fluid">
    <div class="row align-items-center mb-3">
        <div class="col-md-6">
        <h2 class="fw-bold mb-0">Vendor Purchase Report</h2>
        </div>

        <div class="col-md-6 text-md-end mt-2 mt-md-0">
        <button
            pButton
            icon="pi pi-refresh"
            label="REFRESH"
            class="btn btn-primary btn-sm me-2"
            (click)="getReportDetails()">
        </button>

        <button
            pButton
            icon="pi pi-file-excel"
            label="EXCEL"
            class="btn btn-danger btn-sm"
            (click)="getReportDetailsExcel()">
        </button>
        </div>
    </div>
    <!-- FILTER CARD -->
    <div class="card shadow-sm mb-4">
    <div class="card-body">

    <div class="row g-3">

      <!-- Date Range -->
      <div class="col-md-3 col-sm-12">
        <div class="form-group">
        <label class="form-label mb-0 fw-semibold">Date range</label>
        <p-calendar
          [(ngModel)]="dateRange"
          selectionMode="range"
          dateFormat="dd-mm-yy"
          inputStyleClass="form-control w-100"
          appendTo="body"
          style="width: 100%">
        </p-calendar>
        </div>
      </div>
      <!-- Location -->
      <div class="col-md-3 col-sm-12">
        <div class="form-group">
        <label class="form-label fw-semibold">Location</label>
        <p-multiSelect
          [options]="locations"
          optionLabel="displayName"
          display="chip"
          [(ngModel)]="selectedLocations"
          appendTo="body"
          style="width: 100%"
          class="w-100">
        </p-multiSelect>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
            <label class="form-label fw-semibold">Vendor</label>
            <select name="vendorId" [(ngModel)]="vendorId"
                    (change)="getReportDetails()"
                    class="form-select mt-1">
                <option value="0">{{ l('SelectAVendor') }}</option>
                <option *ngFor="let item of allvendors" value="{{ item.id }}">
                    {{ item.displayName }}
                </option>
            </select>
          </div>
        </div>
      <div class="col-md-3">
        <div class="form-group">
            <label class="form-label fw-semibold">Type</label>
            <select name="type" [(ngModel)]="typeId"
                    (change)="getReportDetails()"
                    class="form-select mt-1">
                <option value="1">{{ l('PurchaseOrder') }}</option>
                <option value="2">{{ l('PurchaseInvoice') }}</option>
                <option value="3">{{ l('PurchaseReturn') }}</option>
            </select>
        </div>
        </div>
    </div>

    </div>
    </div>
 <!-- LOADER -->
  <div *ngIf="loading" class="text-center p-4">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>

    <!-- TABLE -->
  <div *ngIf="!loading && purchaseReportOutput != null">

    <div class="table-responsive">
      <table class="table table-bordered table-hover">

        <thead>
          <tr>
            <th>Location</th>
            <th>Vendor Name</th>
            <th>Total Count</th>
            <th>Sub Total</th>
            <th>Tax</th>
            <th>Grand Total</th>
          </tr>
        </thead>
        <tbody >
          <tr *ngFor="let purchaseReportOutputItem of purchaseReportOutput.items">
            <td>{{ purchaseReportOutputItem.locationCode }}</td>
            <td>{{ purchaseReportOutputItem.vendorName }}</td>
            <td>{{ purchaseReportOutputItem.billCount}}</td>
            <td class="text-end">{{ purchaseReportOutputItem.subTotal | number:'1.2-2'}}</td>
            <td class="text-end">{{ purchaseReportOutputItem.tax | number:'1.2-2'}}</td>
            <td class="text-end">{{ purchaseReportOutputItem.grandTotal | number:'1.2-2'}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-dark text-white">
            <td></td>
            <td class="text-center fw-bold">Total</td>
            <td class="fw-bold">
              {{ purchaseReportOutput.dashboard.totalCount }}
            </td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutput.dashboard.subTotal | number:'1.2-2' }}
            </td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutput.dashboard.tax | number:'1.2-2' }}
            </td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutput.dashboard.grandTotal | number:'1.2-2' }}
            </td>
          </tr>
        </tfoot>

      </table>
    </div>

  </div>

</div>